import { createGQLQuery } from 'graphql/helpers'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { mergeMapAsync } from 'rxOperators/mergeMapAsync'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { EpicRefined } from 'interfaces/middleware'
import { combineEpics } from 'redux-observable'

type TestQueryInput = {
  param: number
}
type TestQueryResult = {
  param: number
}
export class GetGQLTestDataAction extends createRequestAction<'GET_GQL_TEST_DATA', TestQueryInput, TestQueryResult>('GET_GQL_TEST_DATA') {}

export type GraphQLTestModuleActions =
  | typeof GetGQLTestDataAction.Type


const TEST_QUERY = `
{
  current_user {username}

  pfm(filters: {timeframe: this_month, comparison: true, category: shopping}) {
    assets
    debts
    networth
    creditscore

    spending_trend {
      ...TrendFields
    }
    income_breakdown {
      ...BreakdownFields
    }
  }
}

fragment TrendFields on Trend {
  average
  actual {
    date
    amount
  }
  projected{
    date
    amount
  }
}


fragment BreakdownFields on Breakdown {
  category
  amount
}
` as const
// use gql<QueryName>Query to simplify lookup query over ide typing suggests
const gqlTestQuery = createGQLQuery<typeof TEST_QUERY, TestQueryResult, TestQueryInput>(TEST_QUERY)


const testEpic: EpicRefined<GraphQLTestModuleActions> = (action$) => action$.pipe(
  filterRequest(GetGQLTestDataAction.type),
  mergeMapAsync(async (action) => {
    try {
      const result = await gqlTestQuery(action.payload.params)
      if (!result.error) {
        return action.success(result.data)
      }

      return action.fail({ errorCode: 400 })

    } catch (e) {
      return action.fail({ errorCode: 400 })
    }
  }),
)

export const testGQLEpic = combineEpics(
  testEpic,
)
